import { REF_CODE_SEARCH_PARAM } from "@garther/ui/libs";
import { Outlet, createRootRoute, useRouterState } from "@tanstack/react-router";
import { useEffect } from "react";

// import { TanStackRouterDevtools } from "@tanstack/router-devtools";
import { AppLoading } from "@/components/app-loading";
import { NotFoundPage } from "@/components/not-found-page";
import { LS_REFERRAL_CODE_KEY } from "@/constants";
import { usePageTracking } from "@/hooks/use-page-tracking";
import { referralApiClient } from "@/libs/api";

export const Route = createRootRoute({
  component: () => Root(),
  notFoundComponent: () => NotFoundPage(),
  validateSearch: (search) => {
    if (search.ref) return { [REF_CODE_SEARCH_PARAM]: search[REF_CODE_SEARCH_PARAM] as string | undefined };
    else return {};
  }
});

const Root = () => {
  const { location } = useRouterState();
  useEffect(() => {
    const code = location.search[REF_CODE_SEARCH_PARAM];
    if (code) {
      referralApiClient
        .verifyCode(code)
        .then(() => {
          localStorage.setItem(LS_REFERRAL_CODE_KEY, code);
        })
        .catch(() => console.log("Invalid referral code"));
    }
  }, [location.search.ref]);

  usePageTracking();
  return (
    <AppLoading>
      <div className="bg-background-primary fixed top-0 left-0 w-full h-full z-[-1]" />
      <div className="relative flex flex-col h-screen w-full">
        <Outlet />
      </div>
      {/* <TanStackRouterDevtools /> */}
    </AppLoading>
  );
};
